import { PhotoECardPreview } from './PhotoECardPreview';

export default PhotoECardPreview;
